const FIELDS_SEPERATOR = ',';

const constructFieldsToString = fieldsInArray => {
  const fieldsInString = fieldsInArray.join(FIELDS_SEPERATOR);
  return { _fields: fieldsInString };
};

export { constructFieldsToString };
